import { config } from "../../../../../enviroment";
import axios from "axios";
import { apolloClientService } from '../../../../../services/apollo-client';
import { commonService } from "../../../../../services";
  export const contentsService = {
    getContentData,
    getAssetData
  };


async function getContentData(
    languageCode,
    categoryCode
  ) {
    return new Promise((resolve, reject) => {
      let apiQuery = `{getContents(input:{languageCode:"` +
      languageCode +
      `",categoryCode:"` +
      categoryCode +
      `"})}`
      apolloClientService.ApolloClientgqls(apiQuery)
        .then((response)=>{
          resolve(response.data);
        })
        .catch((error)=>{
          reject(error);
        });
    });
  }
async function getAssetData(assetCode){
  return new Promise((resolve,reject)=>{
    commonService.getAssestUrl(assetCode).then((res)=>{
      resolve(res)
    })
    .catch(err=>{
      reject(err);
    })
  })
}